<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Online Fees Payment and NEFT Bank Detail</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="inner-title" data-aos="zoom-in-right">
                    <h4>Online Fees Payment and NEFT Bank Detail</h4>
                    <div class="text-line ml-0"></div>
                </div>
                <div class="table-responsive" data-aos="fade-up">
                    <table class="table table-bordered tbl_custom">
                        <thead>
                            <tr>
                                <th>Account Name </th>
                                <th>Account No. </th>
                                <th>IFSC Code </th>
                                <th>Bank </th>
                                <th>Branch</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>G H Raisoni COL OF COM SCI & TEC PAY A/C </td>
                                <td>624205012829 </td>
                                <td>ICIC0006242 </td>
                                <td>ICICI Bank </td>
                                <td>Ramdaspeth, Nagpur</td>
                            </tr>
                            <tr>
                                <td>G H Raisoni Foundation Society Fee Collection A/C</td>
                                <td>624201032748 </td>
                                <td>ICIC0006242 </td>
                                <td>ICICI Bank </td>
                                <td>Ramdaspeth, Nagpur</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- <div class="col-md-4">
                <div class="inner-title"  data-aos="zoom-in-right">
                    <h4>Paytm QR Code to Scan</h4>							
                   
                    <div class="text-center">
                        <img src="assets/images/ghrccst-paytm.webp" alt="ghrccst-paytm" title="Scan To Pay payments" width="300px">
                    </div>
                </div>
            </div> -->


        </div>
    </div>
</section>